import React, { useState, useRef } from 'react';
// Mock Data - Video Testimonials
const TESTIMONIALS = [{
  id: 1,
  title: 'Frankincense 1',
  videoUrl: 'https://cdn.shopify.com/s/files/1/0265/0895/1614/files/reelUp_4tq6myoy0qt1749131907318_short.mp4?v=1749131915',
  poster: 'https://cdn.shopify.com/s/files/1/0265/0895/1614/files/reelUp_4tq6myoy0qt1749131907318_thumbnail_245x.jpg?v=1749131917',
  productName: '2:11 Frankincense',
  price: '£25.00',
  productImage: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Untitled_design_35_8503f1cc-1331-4259-a2e1-dd84b205529f.png?v=1764367948'
}, {
  id: 2,
  title: 'Frankincense 2',
  videoUrl: 'https://cdn.shopify.com/s/files/1/0265/0895/1614/files/reelUp_h96iun7fok1749131968367_short.mp4?v=1749131978',
  poster: 'https://cdn.shopify.com/s/files/1/0265/0895/1614/files/reelUp_h96iun7fok1749131968367_thumbnail_245x.jpg?v=1749131981',
  productName: '2:11 Frankincense',
  price: '£25.00',
  productImage: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Untitled_design_35_8503f1cc-1331-4259-a2e1-dd84b205529f.png?v=1764367948'
}, {
  id: 3,
  title: 'Frankincense 3',
  videoUrl: 'https://cdn.shopify.com/s/files/1/0265/0895/1614/files/reelUp_cgtzy77l1jp1749132322538_short.mp4?v=1749132341',
  poster: 'https://cdn.shopify.com/s/files/1/0265/0895/1614/files/reelUp_cgtzy77l1jp1749132322538_thumbnail_245x.jpg?v=1749132337',
  productName: '2:11 Frankincense',
  price: '£25.00',
  productImage: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Untitled_design_35_8503f1cc-1331-4259-a2e1-dd84b205529f.png?v=1764367948'
}, {
  id: 4,
  title: 'Frankincense 4',
  videoUrl: 'https://cdn.shopify.com/s/files/1/0265/0895/1614/files/reelUp_lyt23hq7v21749132412377_short.mp4?v=1749132423',
  poster: 'https://cdn.shopify.com/s/files/1/0265/0895/1614/files/reelUp_lyt23hq7v21749132412377_thumbnail_245x.jpg?v=1749132423',
  productName: '2:11 Frankincense',
  price: '£25.00',
  productImage: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Untitled_design_35_8503f1cc-1331-4259-a2e1-dd84b205529f.png?v=1764367948'
}];
interface VideoCardProps {
  item: (typeof TESTIMONIALS)[0];
}
function VideoCard({
  item
}: VideoCardProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const handleMouseEnter = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };
  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };
  return <div className="card-container" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} data-id="element-511">
      <div className="video-wrapper" data-id="element-512">
        <video ref={videoRef} src={item.videoUrl} poster={item.poster} muted loop playsInline className="video-element" data-id="element-513" />

        {/* Apple-style Play Icon Overlay (Fades out on hover) */}
        <div className={`play-overlay ${isPlaying ? 'hidden' : ''}`} data-id="element-514">
          <div className="play-button" data-id="element-515">▶</div>
        </div>

        {/* Gradient Overlay for Text Readability */}
        <div className="gradient-overlay" data-id="element-516"></div>

        {/* Frosted Glass Product Tag */}
        <div className="product-tag glass-panel" data-id="element-517">
          <img src={item.productImage} alt="Product" className="product-thumb" data-id="element-518" />
          <div className="product-info" data-id="element-519">
            <span className="product-name" data-id="element-520">{item.productName}</span>
            <span className="product-price" data-id="element-521">{item.price}</span>
          </div>
          <div className="shop-arrow" data-id="element-522">→</div>
        </div>
      </div>
    </div>;
}
export function VideoTestimonialsSection() {
  return <>
      <style data-id="element-523">{`
        .ff-section {
          background-color: #FEFDFB;
          padding: 80px 20px;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #496f58;
          overflow: hidden;
        }

        .ff-container {
          max-width: 1400px;
          margin: 0 auto;
        }

        /* Typography */
        .ff-heading {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 2.3rem;
          font-weight: 600;
          text-align: center;
          margin-bottom: 1rem;
          color: #496f58;
          letter-spacing: -0.02em;
        }

        .ff-subheading {
          text-align: center;
          font-size: 0.9rem;
          color: #8c9fa5; 
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 15px;
          font-weight: 600;
        }

        /* Carousel Scroll Area */
        .carousel-track {
          display: flex;
          gap: 24px;
          overflow-x: auto;
          padding: 20px 20px 60px 20px;
          scroll-snap-type: x mandatory;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
        }
        
        .carousel-track::-webkit-scrollbar {
          display: none;
        }

        /* Card Styles */
        .card-container {
          flex: 0 0 auto;
          width: 280px;
          height: 500px;
          position: relative;
          border-radius: 24px;
          overflow: hidden;
          scroll-snap-align: center;
          transition: transform 0.4s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.4s ease;
          cursor: pointer;
          background: #E8DFD4;
        }

        .card-container:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px -10px rgba(73, 111, 88, 0.3);
        }

        .video-wrapper {
          width: 100%;
          height: 100%;
          position: relative;
        }

        .video-element {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* Overlays */
        .play-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,0.1);
          transition: opacity 0.3s ease;
        }
        
        .play-overlay.hidden {
          opacity: 0;
        }

        .play-button {
          width: 50px;
          height: 50px;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(4px);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 14px;
          border: 1px solid rgba(255,255,255,0.6);
        }

        .gradient-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 40%;
          background: linear-gradient(to top, rgba(73, 111, 88, 0.4), transparent);
          pointer-events: none;
        }

        /* Glassmorphism Product Tag - Apple Style */
        .product-tag {
          position: absolute;
          bottom: 16px;
          left: 16px;
          right: 16px;
          padding: 8px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          background: rgba(254, 253, 251, 0.85);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.5);
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        .product-thumb {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          object-fit: cover;
        }

        .product-info {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .product-name {
          font-size: 12px;
          font-weight: 600;
          color: #496f58;
          line-height: 1.2;
        }

        .product-price {
          font-size: 11px;
          color: #C9A962;
          font-weight: 500;
        }

        .shop-arrow {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #496f58;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          margin-right: 4px;
        }

        /* Disclaimer */
        .disclaimer {
          text-align: center;
          font-size: 0.75rem;
          color: #8c9fa5;
          max-width: 600px;
          margin: 20px auto 0;
          line-height: 1.5;
          opacity: 0.8;
        }

        /* Mobile Optimization */
        @media (max-width: 768px) {
          .ff-heading { 
            font-size: 2rem; 
          }
          .card-container { 
            width: 240px; 
            height: 420px; 
          }
          .ff-section { 
            padding: 40px 0; 
          }
        }
      `}</style>

      <section className="ff-section" data-id="element-524">
        <div className="ff-container" data-id="element-525">
          <div className="ff-subheading" data-id="element-526">
            Here's Why So Many Are Back to Living With Purpose
          </div>
          <h2 className="ff-heading" data-id="element-527">Real Stories, Real Comfort</h2>

          <div className="carousel-track" data-id="element-528">
            {TESTIMONIALS.map(item => <VideoCard key={item.id} item={item} data-id="element-529" />)}
          </div>
        </div>
      </section>
    </>;
}